<template>
  <div class="home">
    <div class="tabbar">
      <van-row>
        <van-col span="8" v-for="(item, index) of tabbar" :key="item.name">
          <van-popover
            get-container=".home"
            style="width: 100%"
            v-model="item.showPopover"
            trigger="click"
            placement="top"
            :actions="selectActions"
            @open="handleOpen(index)"
            @select="onSelect"
          >
            <template #reference>
              <van-button hairline color="#fbfbfb" style="width: 100%">{{ item.name }}</van-button>
            </template>
          </van-popover>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data: () => ({
    tabbar: [
      { name: '参观服务', showPopover: false },
      { name: '展览导览', showPopover: false },
      { name: '综合服务', showPopover: false }
    ],
    actions: [
      [
        {
          text: '山西博物院预约',
          path: ''
        },
        {
          text: '青铜分馆预约',
          path: '',
          link: 'https://wap.lotsmall.cn/vue/detail/ticket?id=3969&productCode=park2020031415594473647&m_id=758'
        },
        {
          text: '参观须知',
          path: '/Notice'
        },
        {
          text: 'App下载',
          path: '/download'
        },
        {
          text: '文创商店',
          path: '',
          link: 'https://shop330411124.taobao.com'
        }
      ],
      [
        { text: '临时展览', path: '/exhibitSwiper' },
        { text: '线上展览', path: '/exhibit/exhibitlist' },
        // { text: '语音导览', path: '' },
        { text: '视频在线', path: '/exhibit/videoOnline' }
      ],
      [
        { text: '文物鉴赏', path: '/culturalRelic' },
        { text: '教育活动', path: '/educational' },
        { text: '志愿者', path: '/volunteer' }
      ]
    ],
    selectActions: []
  }),
  methods: {
    handleOpen (index) {
      this.selectActions = this.actions[index]
    },
    onSelect (action, index) {
      console.log(action, index)
      if (this.selectActions[index].link) {
        window.location.href = this.selectActions[index].link
        return
      }
      this.$router.push(this.selectActions[index].path)
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  position: relative;
  background-color: #f5f5f5;
  .tabbar {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  ::v-deep .van-button {
    color: #888 !important;
    outline: 1px solid #e7e5e5;
  }
  ::v-deep .van-popover__action {
    white-space: nowrap;
  }
}
</style>
